import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { dataMetaSelector } from "Bands/state";
import { Modal } from "shared/components";
import { IAPIState, IFormButtons, IStatus } from "shared/types";
import { addTemporaryToast } from "shared/components/Toast";
import { useBandRoute, useClearActionMetaOnUnMount } from "Bands/utils";

interface Props {
  icon?: React.ComponentType<any>;
  handleClose: () => void;
  action: string;
  successMessage: string;
  title: string;
  buttons: IFormButtons;
  handleSubmit: (data: any) => void;
  handleSuccess?: () => void;
  Component: React.ComponentType<any>;
  defaultValues?: Record<string, any>;
}

export const UserEntityModal: FC<Props> = ({
  title,
  icon,
  action,
  buttons,
  successMessage,
  handleSubmit,
  handleSuccess,
  handleClose,
  Component,
  defaultValues,
}) => {
  const dispatch = useDispatch();
  const { pushRoute } = useBandRoute();

  const { api: apiMeta } = useSelector(dataMetaSelector(action));
  useClearActionMetaOnUnMount(action);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      handleSuccess && handleSuccess();

      handleClose();

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: successMessage,
        })
      );
    }
  }, [
    apiMeta,
    handleClose,
    pushRoute,
    dispatch,
    successMessage,
    handleSuccess,
  ]);

  return (
    <Modal title={title} icon={icon} handleClose={handleClose}>
      <Component
        handleSubmit={handleSubmit}
        apiStatus={apiMeta?.status}
        buttons={buttons}
        error={!!apiMeta?.error}
        apiError={apiMeta?.error}
        defaultValues={defaultValues}
      />
    </Modal>
  );
};
